import {ReactNode} from "react";


interface PageProps {
    full?: boolean,
    className?: string,
    children?: ReactNode
}

export default function Page({full=false, className='', children}: PageProps) {
    if(full) {
        return <div className={`page-full ${className}`}>{children}</div>
    } else {
        return <div className={`page ${className}`}>{children}</div>
    }
}
